import React from 'react';
import MultiSelectField from './MultiSelectField';
import YearRangeField from './YearRangeField';

const FiltersPanel = ({
  // Data
  userBranches,
  departments,
  skillsKnown,
  companyLocations,
  experiences,
  courses,

  // Pending states
  pendingBranches,
  pendingDepartments,
  pendingSkillsKnown,
  pendingCourses,
  pendingCompanyLocations,
  pendingExperiences,
  pendingResumeStatus,
  pendingFromPassedYear,
  pendingToPassedYear,
  pendingGenders,


  // Setters
  setPendingGenders,
  setPendingBranches,
  setPendingDepartments,
  setPendingSkillsKnown,
  setPendingCourses,
  setPendingCompanyLocations,
  setPendingExperiences,
  setPendingResumeStatus,
  setPendingFromPassedYear,
  setPendingToPassedYear,
  pendingReadyForPlacement,
  setPendingReadyForPlacement,

  // Actions
  clearAllFilters,
  handleApplyFilters,
  isApplyingFilters,
  hasPendingChanges,
  type = "placementEligible"
}) => {
  return (
    <div className="advanced-filters-panel">
      <div className="filters-grid">
        {type === "placementEligible" && (
          <MultiSelectField
            label="Branch"
            options={userBranches}
            selectedValues={pendingBranches}
            onChange={setPendingBranches}
            placeholder="Select branches..."
            searchPlaceholder="Search branches..."
          />
        )}

        <div className="multi-select-field">
          <label>Department:</label>
          <div className="multi-select-container">
            <select
              value={pendingDepartments[0] || ""}
              onChange={(e) => {
                const value = e.target.value;
                setPendingDepartments(value ? [value] : []);
                setPendingSkillsKnown([]);
                setPendingCourses([]);
              }}
            >
              <option value="">Select department...</option>
              {departments.map((dept) => (
                <option key={dept} value={dept}>
                  {dept}
                </option>
              ))}
            </select>
          </div>
        </div>

        <MultiSelectField
          label="Skills Known"
          options={skillsKnown}
          selectedValues={pendingSkillsKnown}
          onChange={setPendingSkillsKnown}
          placeholder={
            pendingDepartments.length === 0
              ? "Select a Department to display Skills"
              : "Select skills..."
          }
          searchPlaceholder="Search skills..."
          disabled={pendingDepartments.length === 0}
        />

        <MultiSelectField
          label="Course Name"
          options={courses}
          selectedValues={pendingCourses}
          onChange={setPendingCourses}
          placeholder={
            pendingDepartments.length === 0
              ? "Select a Department to display Courses"
              : "Select courses..."
          }
          searchPlaceholder="Search courses..."
          disabled={pendingDepartments.length === 0}
          keepSearchOnSelect={true}
        />

        <MultiSelectField
          label="Preferred Job Location"
          options={companyLocations}
          selectedValues={pendingCompanyLocations}
          onChange={setPendingCompanyLocations}
          placeholder="Select locations..."
          searchPlaceholder="Search locations..."
        />

        <MultiSelectField
          label="Experience"
          options={experiences}
          selectedValues={pendingExperiences}
          onChange={setPendingExperiences}
          placeholder="Select experience levels..."
          searchPlaceholder="Search experience..."
        />

        <div className="multi-select-field">
          <label>Resume Status:</label>
          <div className="multi-select-container">
            <select
              value={pendingResumeStatus}
              onChange={(e) => setPendingResumeStatus(e.target.value)}
            >
              <option value="">All Students</option>
              <option value="uploaded">Resume Uploaded</option>
              <option value="not_uploaded">Resume Not Uploaded</option>
            </select>
          </div>
        </div>
        <MultiSelectField
          label="Gender"
          options={['Male', 'Female', 'Other']}
          selectedValues={pendingGenders}
          onChange={setPendingGenders}
          placeholder="Select gender..."
          searchPlaceholder="Search gender..."
        />
        <YearRangeField
          label="Passed Out Year"
          fromYear={pendingFromPassedYear}
          toYear={pendingToPassedYear}
          onFromYearChange={setPendingFromPassedYear}
          onToYearChange={setPendingToPassedYear}
        />
        {type !== "placementEligible" && (
          <div className="filter-group">
            <label>Ready For Placement</label>
            <select
              value={pendingReadyForPlacement}
              onChange={(e) => setPendingReadyForPlacement(e.target.value)}
            >
              <option value="">All</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        )}
      </div>

      <div className="filters-actions">
        <button onClick={clearAllFilters} className="clear-btn">
          Clear All Filters
        </button>

        <button
          onClick={handleApplyFilters}
          className="apply-filters-btn"
          disabled={isApplyingFilters || !hasPendingChanges()}
        >
          {isApplyingFilters ? (
            <>
              <span className="loading-spinner">⟳</span>
              Applying...
            </>
          ) : (
            <>
              <span>✓</span>
              Apply Filters
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default React.memo(FiltersPanel);